<template>
  <div class="msg">
    <!-- <div class="pic-box">
        <div class="entity">
            <div class="imgw">
                <img :src="data[0].url" alt="">
            </div>
            <div class="des">
                <div class="text-intro">
                    <div class="title">
                        <span class="ch">{{data[0].name}}</span>
                        <span class="eng">{{data[0].nameEn}}</span>
                    </div>
                    <div class="cont">{{data[0].content}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="text" v-for='(i,k) in desLs' :key='k'>
        <div class="title">
            <span>{{i.name}}</span>
        </div>
        <div class="cont">
            <span>{{i.content}}</span>
        </div>
    </div>
    <div class="banner">
        <div :class="{active: k%2!==0}" class="item" v-for='(i,k) in new Array(3)' :key='k'>
            <img :src="require('@/assets/image/case_item_bg.jpg')" alt="">
        </div>
    </div> -->
    <ul>
      <li v-for='(i,k) in showData' :key='k' @click="goDetail(i)">{{i.name}}</li>
    </ul>
    <div class="page">
      <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
      <div class="item" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
        <div @click="currentPage(k)">{{k+1}}</div>
      </div>
      <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: Array
    },
    data() {
      return {
        showData: [],
        total: this.data.length,
        size: 10,
        current: 0
      }
    },
    methods: {
      goDetail(i) {
        this.$emit('detail', i)
      },
      nextPage() {
        if (this.current + 1 == Math.ceil(this.total / this.size)) {
        } else {
          this.current = this.current + 1;
        }
      },
      // 上一页
      prePage() {
        if (this.current == 0) {
        } else {
          this.current = this.current - 1;
        }
      },
      // 点击页码
      currentPage(i) {
        this.current = i;
        this.watch
      }
    },
    watch: {
      data: function (newData, oldData) {
        console.log("order", newData)  //newData就是orderData
        this.total = newData.length;
        this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值

      },
      current: function (newData, oldData) {
        console.log("current", newData)  //newData就是orderData
        this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"


  theme = #f7aa05

  .msg
    mt(20)
    min-height 350px

    ul
      pl(30)

      li
        fs(17)
        c(gray)
        lh(37)
        _hover()

    .banner
      mt(50)
      h(180)
      _flex()

      .item
        width 30%
        hh()

        &.active
          ml(58)
          mr(58)

        img
          wh()

    .text
      c(rgb(121, 120, 118))

      .title
        c(gray)
        pb(35)
        pt(55)

        span
          fs(18)

      .cont
        span
          fs(14)
          lh(22)

    .pic-box
      w(520)
      h(270)
      border 2px solid #333
      ppr()

      .entity
        ppa()
        top 0
        bottom 0
        height 80%
        margin auto 0
        width 80%
        right 0

        .imgw
          ppa()
          wh()

          img
            wh()

        .des
          ppr()
          hh()
          w(600)
          bg(theme)
          transform translateX(convert(390))
          _flex()
          c(#fff)

          .text-intro
            pr(20)
            pl(20)

            .title
              fs(12)
              ta(right)
              mb(20)

              .ch
                fs(22)

              .eng
                fs(14)
                pl(14)

            .cont
              fs(12)
              lh(25)

  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)
</style>



// WEBPACK FOOTER //
// src/components/msg/msg.vue